import _ from "lodash";

export class AccountingsKpiEntity {
    constructor(props) {
        this.props = props;
    }

    getScoreStatus() {
        const status = {
            ALTO: {
                label: "Alto",
                class: "score-cyan"
            },
            MEDIO: { label: "Médio", class: "score-yellow" },
            BAIXO: { label: "Baixo", class: "score-pink" }
        };

        return status[_.get(this.props, "score.result") || "BAIXO"];
    }
    getScore() {
        return [
            {
                value: _.get(this.props, "score.customers.low"),
                label: "baixos"
            },
            {
                value: _.get(this.props, "score.customers.medium"),
                label: "médios"
            },
            {
                value: _.get(this.props, "score.customers.high"),
                label: "alto"
            }
        ];
    }

    getLevels() {
        return [
            {
                tooltip: "Bronze 0",
                class: "bronze-medal-0",
                icon: "fas fa-award",
                value: this.props?.impact?.["Bronze 0"]?.total || 0
            },
            {
                tooltip: "Bronze 1",
                class: "bronze-medal-1",
                icon: "fas fa-award",
                value: this.props?.impact?.["Bronze 1"]?.total || 0
            },
            {
                tooltip: "Bronze 2+",
                class: "bronze-medal-2",
                icon: "fas fa-award",
                value: this.props?.impact?.["Bronze 2+"]?.total || 0
            },
            {
                tooltip: "Prata",
                class: "default-medal",
                icon: "fas fa-award",
                value: this.props?.impact?.Prata?.total || 0
            },
            {
                tooltip: "Ouro",
                class: "gold-medal",
                icon: "fas fa-award",
                value: this.props?.impact?.Ouro?.total || 0
            },
            {
                tooltip: "Embaixador",
                class: "petroleum-medal",
                icon: "fas fa-award",
                value: this.props?.impact?.Embaixador?.total || 0
            }
        ];
    }

    getStatus(page) {
        const pages = {
            1: [
                {
                    value: _.get(this.props, "status.customers.active"),
                    label: "ativas"
                },
                {
                    value: _.get(this.props, "status.customers.suspended"),
                    label: "susp"
                },
                {
                    value: _.get(this.props, "status.customers.inactive"),
                    label: "inativas"
                }
            ],
            2: [
                {
                    value: _.get(this.props, "status.trial.active"),
                    label: "vigentes"
                },
                {
                    value: _.get(this.props, "status.trial.inactive"),
                    label: "expirados"
                }
            ]
        };

        return pages[page];
    }

    getPagesAmbassador(page) {
        const geral = this.props?.impact?.Geral;
        const embaixador = this.props?.impact?.Embaixador;
        const ouro = this.props?.impact?.Ouro;
        const prata = this.props?.impact?.Prata;
        const bronze = this.props?.impact?.Bronze;

        const pages = {
            // Geral
            1: [
                {
                    value: geral?.engajado || 0,
                    label: "engajados"
                },
                {
                    value: geral?.desengajado,
                    label: "desengajados"
                }
            ],
            // Embaixador
            2: [
                {
                    value: embaixador?.engajado || 0,
                    label: "engajados"
                },
                {
                    value: embaixador?.desengajado || 0,
                    label: "desengajados"
                }
            ],
            // Ouro
            3: [
                {
                    value: ouro?.engajado || 0,
                    label: "engajados"
                },
                {
                    value: ouro?.desengajado || 0,
                    label: "desengajados"
                }
            ],
            // Prata
            4: [
                {
                    value: prata?.engajado || 0,
                    label: "engajados"
                },
                {
                    value: prata?.desengajado,
                    label: "desengajados"
                }
            ],
            // Bronze
            5: [
                {
                    value: bronze?.engajado,
                    label: "engajados"
                },
                {
                    value: bronze?.desengajado,
                    label: "desengajados"
                }
            ]
        };

        return pages[page];
    }

    getPolarityBillingTotal() {
        return {
            status:
                _.get(this.props, "billing.score.medium.polarity") < 0
                    ? "DOWN"
                    : "UP",
            value: this._formatPercentage(
                _.get(this.props, "billing.score.medium.variation")
            )
        };
    }
    getBillingTotal() {
        return [
            {
                value: (_.get(this.props, "billing.total") || 0).toLocaleString(
                    "pt-BR",
                    {
                        style: "currency",
                        currency: "BRL"
                    }
                )
            }
        ];
    }

    getStatus(page) {
        const pages = {
            1: [
                {
                    value: _.get(this.props, "status.customers.active"),
                    label: "ativas"
                },
                {
                    value: _.get(this.props, "status.customers.suspended"),
                    label: "susp"
                },
                {
                    value: _.get(this.props, "status.customers.inactive"),
                    label: "inativas"
                }
            ],
            2: [
                {
                    value: _.get(this.props, "status.trial.active"),
                    label: "vigentes"
                },
                {
                    value: _.get(this.props, "status.trial.inactive"),
                    label: "expirados"
                }
            ]
        };

        return pages[page];
    }

    getPolarityScore(page) {
        const pages = {
            1: {
                status:
                    _.get(this.props, "billing.score.low.polarity") < 0
                        ? "DOWN"
                        : "UP",
                value: this._formatPercentage(
                    this.props.billing.score.low.variation
                )
            },
            2: {
                status:
                    _.get(this.props, "billing.score.medium.polarity") < 0
                        ? "DOWN"
                        : "UP",
                value: this._formatPercentage(
                    _.get(this.props, "billing.score.medium.variation")
                )
            },
            3: {
                status:
                    _.get(this.props, "billing.score.high.polarity") < 0
                        ? "DOWN"
                        : "UP",
                value: this._formatPercentage(
                    _.get(this.props, "billing.score.high.variation")
                )
            }
        };

        return pages[page];
    }
    getBillingScore(page) {
        const pages = {
            1: [
                {
                    value: _.get(
                        this.props,
                        "billing.score.low.total"
                    ).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                    })
                }
            ],
            2: [
                {
                    value: _.get(
                        this.props,
                        "billing.score.medium.total"
                    ).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                    })
                }
            ],
            3: [
                {
                    value: _.get(
                        this.props,
                        "billing.score.high.total"
                    ).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                    })
                }
            ]
        };

        return pages[page];
    }

    getAverageTicket() {
        return [
            {
                value: (
                    _.get(this.props, "averageTicket.total") || 0
                ).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                })
            }
        ];
    }

    getPolarityAverageTicket() {
        return {
            status:
                _.get(this.props, "averageTicket.polarity") < 0 ? "DOWN" : "UP",
            value: this._formatPercentage(
                this.props?.averageTicket?.variation || 0
            )
        };
    }
    /**
     * Total de cada aba de filtro rápido da tela Administrativo.
     *
     * Vem contado na hora pelo back, sobre a mesma população da listagem — é o que faz o número
     * do chip bater com o tamanho da lista. Objeto vazio enquanto a Lambda publicada não tiver
     * o campo: aí a aba aparece sem contagem, em vez de aparecer com zero.
     */
    getCustomersTabs() {
        return _.get(this.props, "customersTabs") || {};
    }

    _formatPercentage(value) {
        return new Intl.NumberFormat("pt-BR", {
            style: "percent",
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(Math.abs(value));
    }
}
